import { API_CALL } from '../../../../../middleware/api';
import { WIDGET_GET_DEVICES_COUNT } from './constants';

export const actions = {
  getDevicesCount: request => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/hubs-devices-count',
      params: request,
    },
    type: WIDGET_GET_DEVICES_COUNT,
    request,
  }),
};
